import React from "react";

export function SectionDivider() {
  return <div className="divider"><div className="container"></div></div>
}
export default SectionDivider;
